import apiFarms from "../config/api_farms";
// import { getMockAreaData } from "../pages/picket/dashboards/areaMap/mocks/selectedAreaDataMock";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082",
// });

// const mockAreaData = getMockAreaData('Extensive');

export function getFarmMaps(payload) {
  const { groupId, farmId, signal } = payload;
  let url = `/bovexo/${groupId}/farms/${farmId}/properties/map`;

  return apiFarms.get(url, getHeaders(false, signal));
}

export function getFarmMapsAnimalData(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/properties/map/${id}/animals/statistics`,
    getHeaders(false, signal)
  );
}

export function saveFarmMap(payload) {
  const { groupId, farmId, mapData, signal } = payload;
  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/properties/map`,
    mapData,
    getHeaders(false, signal)
  );
}

export function updateFarmMap(payload) {
  const { groupId, farmId, id, mapData, signal } = payload;
  return apiFarms.put(
    `/bovexo/${groupId}/farms/${farmId}/properties/map/${id}`,
    mapData,
    getHeaders(false, signal)
  );
}

export function deleteFarmMap(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiFarms.delete(
    `/bovexo/${groupId}/farms/${farmId}/properties/map/${id}`,
    getHeaders(false, signal)
  );
}
